import { Injectable, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';

import * as EnableMfaActions from './mfa-preference.actions';
import { MfaMethod } from '@fantaz/shared/data-access/api';
import {
  isAuthenticatorMfaEnabled,
  isSmsMfaEnabled,
  selectChangeTOTPMfAPreference,
  selectEnableMfaLoaded,
  selectEnableMfaLoading,
} from './mfa-preference.selectors';
import { UpdateMFAPreferenceInput } from 'aws-amplify/auth';
import { CoreRouterActions } from '@fantaz/core';

@Injectable()
export class MfaPreferenceFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.select(selectEnableMfaLoaded);
  loading$ = this.store.select(selectEnableMfaLoading);

  isSmsMfaEnabled$ = this.store.select(isSmsMfaEnabled);
  isAuthenticatorMfaEnabled$ = this.store.select(isAuthenticatorMfaEnabled);
  changeTOTPMfAPreference$ = this.store.select(selectChangeTOTPMfAPreference);

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  updateMFAPreference(enableMfaMethod: UpdateMFAPreferenceInput) {
    this.store.dispatch(
      EnableMfaActions.updateMFAPreferenceMfa({
        updateMFAPreference: enableMfaMethod,
      }),
    );
  }

  loadMfAPreference() {
    this.store.dispatch(EnableMfaActions.AuthMFAActions.loadMfAPreference());
  }

  changeTotpMfaPreference() {
    this.store.dispatch(EnableMfaActions.changeTotpMfaPreference());
  }

  openAuthenticatorMfa() {
    this.store.dispatch(
      CoreRouterActions.navigate(
        ['', { outlets: { dialog: 'authenticator-mfa' } }],
        { replaceUrl: true },
      ),
    );
  }
}
